import React from "react";
import { Box, Container, Typography, Paper } from "@mui/material";
import TeamPic from "./Team_Pic_Long_Beach.jpeg";
import LandingHeaderLogo from "./assets/LandingHeaderLogo.svg";

const ThankYouPage = () => {
  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Box sx={{ display: "flex", justifyContent: "center", mb: 4 }}>
          <img
            src={LandingHeaderLogo}
            alt="DGI Logo"
            style={{ width: "100px", height: "100px" }}
          />
        </Box>
        <Typography
          variant="h4"
          component="h1"
          gutterBottom
          align="center"
          sx={{ mb: 4 }}
        >
          Thank You, From All of Us at DGI Apparel
        </Typography>

        <Typography variant="body1" paragraph>
          After 2 years of serving the custom apparel community, we've made the
          difficult decision to wind down operations at DGI Apparel. This
          message isn't about what could have been—it's a thank-you to everyone
          who believed in what we were building.
        </Typography>

        <Typography variant="body1" paragraph>
          DGI started the way many good ideas do: from inside a small print
          shop. I was a high school screen printer in North Carolina, working
          under Jay, a shop owner who loved his customers and community—but
          spent far too many hours trying to track down inventory. Like most
          decorators, we just assumed that chasing down stock, comparing prices,
          and managing backorders was part of the job.
        </Typography>

        <Typography variant="body1" paragraph>
          Years later, I shared those frustrations with two college roommates,
          Grant and Daniel. With their engineering backgrounds and my shop-floor
          experience, we realized we could build something better—something that
          would help shops like Jay's, and like yours, cut through the chaos of
          wholesale purchasing.
        </Typography>

        <Typography variant="body1" paragraph>
          So we did. With the help of hundreds of decorators across the country,
          DGI grew from an idea to a platform that served over 2,800 apparel
          businesses. You helped shape it, stress-test it, and improve it. You
          sent feature requests, bug reports, and words of encouragement that
          kept us going through every late night. You proved that this industry
          wants—and deserves—tools that respect your time and support your
          margins.
        </Typography>

        <Typography variant="body1" paragraph>
          Whether you used DGI once or every day, whether you shared it with a
          friend or simply trusted us with your business: thank you. We didn't
          chase headlines or growth for growth's sake. We just tried to build
          something helpful. Something that made life a little easier for the
          people who make things with their hands and serve their communities
          with care.
        </Typography>

        <Typography variant="body1" paragraph>
          We're proud of what we built, and even prouder of who we built it for.
        </Typography>

        <Typography variant="body1" paragraph>
          To Jay—thank you for the years of mentorship that started this whole
          thing. To our early beta users—thank you for trusting three college
          friends with your workflow. And to every shop owner and staffer who
          gave DGI a shot—we'll always be grateful.
        </Typography>

        <Typography variant="body1" paragraph>
          Though we won't be continuing the platform, we still believe in the
          mission: helping decorators thrive in a tough, essential industry.
          Although DGI won't be continuing, that mission won't end here — and we
          can't wait to see what the community builds next.
        </Typography>

        <Typography variant="body1" paragraph sx={{ mt: 4 }}>
          With deep appreciation,
        </Typography>
        <Typography variant="body1" paragraph>
          Daniel, Grant, Ian & the entire DGI Team
        </Typography>

        <Box sx={{ display: "flex", justifyContent: "center", my: 6 }}>
          <img
            src={TeamPic}
            alt="DGI Apparel Team at Long Beach"
            style={{
              maxWidth: "100%",
              height: "auto",
              borderRadius: 8,
              boxShadow: "0 4px 24px rgba(0,0,0,0.12)",
            }}
          />
        </Box>

        <Box sx={{ mt: 6, p: 3, bgcolor: "grey.100", borderRadius: 1 }}>
          <Typography variant="body1" paragraph>
            We're very busy as we go through this process, but you can reach us
            at{" "}
            <Typography
              component="a"
              href="mailto:team@dgiapparel.com"
              sx={{ color: "primary.main" }}
            >
              team@dgiapparel.com
            </Typography>{" "}
            and we'll get back to you as soon as we can.
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default ThankYouPage;
